import { DeleteTwoTone } from '@ant-design/icons';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App, Popconfirm } from 'antd';
import { useState } from 'react';
import { deleteZipCode } from '../../../api';
import { components } from '../../../api/schema';
import { DataTableActionProps } from '../../../shared/dataTable/DataTable';

export const DeleteZipCode = ({ record }: DataTableActionProps<components['schemas']['ZipcodeCondensed']>) => {
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);
  const { message } = App.useApp();
  const mutation = useMutation({
    mutationFn: (id: string) => deleteZipCode(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getZipCodes'] });
      message.success('Código postal eliminado correctamente');
    },
    onError: () => {
      message.error('Ocurrio un error, vuelve a intentarlo más tarde');
    },
  });

  return (
    <Popconfirm
      title="Eliminar"
      description={`Estas seguro que deseas eliminar el C.P. ${record.zipCode} - ${record.district}?`}
      open={open}
      onConfirm={() => mutation.mutate(record.id)}
      okButtonProps={{ loading: mutation.isLoading }}
      onCancel={() => setOpen(false)}
      cancelText="Cancelar"
      okText="Eliminar"
    >
      <DeleteTwoTone twoToneColor={'#cf1322'} onClick={() => setOpen(true)} />
    </Popconfirm>
  );
};
